import { t } from 'i18next';
import { Resource, useDeleteCallback, useRefreshCollection } from 'json-api-hooks';
import React, { FormEvent } from 'react';
import { useNavigate } from 'react-router';

import Button from '../components/././Button';
import FormFooter from '../components/./Form/FormFooter';
import CardContent from '../components/Card/CardContent';
import CardMain from '../components/Card/CardMain';
import Container from '../components/Container';
import Heading from '../components/Heading';
import Markdown from '../components/Markdown';
import { ModalProps } from '../components/Modal/ModalContextProvider';
import useSnackbar from '../hooks/useSnackbar';
import retrievePath from '../lib/iris';

export interface DestroyResourceModalProps {
  description: string;
  resource: Resource;
  label?: string;
  redirect?: boolean;
  onSuccess?: () => void;
  successMessage?: string;
}

const DeleteResourceModal = ({
  description,
  handleClose,
  label,
  onSuccess,
  redirect,
  resource,
  successMessage,
}: ModalProps<DestroyResourceModalProps>) => {
  const showSnackbar = useSnackbar();
  const refreshCollection = useRefreshCollection();
  const navigate = useNavigate();
  const [destroyCallback, loading] = useDeleteCallback(resource);
  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    destroyCallback()
      .then((result) => {
        refreshCollection(resource.type);

        if (redirect) {
          const location = result.response.headers.get('Location');

          if (location) {
            navigate(retrievePath(location));
          }
        }
        if (onSuccess) {
          onSuccess();
        }

        handleClose();
        showSnackbar(successMessage ?? 'Het item is verwijderd');
      })
      .catch(() => {});
  };

  return (
    <Container>
      <CardMain>
        <CardContent endSpacing>
          <Heading>{label ?? 'Verwijderen'}</Heading>
          <Markdown text={description} />
          <form onSubmit={handleSubmit}>
            <FormFooter>
              <Button variant="text" onClick={handleClose}>
                {t('form.cancel')}
              </Button>
              <Button loading={loading} type="submit">
                {label ?? 'Verwijderen'}
              </Button>
            </FormFooter>
          </form>
        </CardContent>
      </CardMain>
    </Container>
  );
};

export default DeleteResourceModal;
